import {
    isAfter,
    isSameDay,
    parseISO,
} from "date-fns";
import getStandingCommitteesOnly from "./getStandingCommitteesOnly";
import { matchesMeetingsByDateRange } from "./FilterMeetingsByDates";

const filterStandingCommittees = async (
    filteredCommittees,
    dateRange,
    selectedLegislators,
    selectedChambers,
    selectedBills,
    // selectedBillTypes,
    selectedBillStatus,
    onlyMeetingsWithBillHearing
) => {
    const now = new Date();

    let standingCommittees = getStandingCommitteesOnly(filteredCommittees)
        .map((committee) => {
            if (!committee.meetingTimes) return null;

            const filteredMeetingTimes = committee.meetingTimes.filter((meetingTime) => {
                const meetingDate = new Date(meetingTime.meetingTime);
                return !dateRange
                    ? isAfter(meetingDate, now) || isSameDay(meetingDate, now)
                    : matchesMeetingsByDateRange(meetingDate, dateRange);
            });

            if (filteredMeetingTimes.length === 0) return null;

            return { ...committee, meetingTimes: filteredMeetingTimes };
        })
        .filter(Boolean);

    if (onlyMeetingsWithBillHearing || (selectedLegislators && selectedLegislators.legs.length > 0)) {
        standingCommittees = standingCommittees.filter((committee) => {
            committee.meetingTimes = committee.meetingTimes.filter((meeting) => meeting.bills && meeting.bills.length > 0);

            return committee.meetingTimes.length > 0;
        });
    }

    if (selectedLegislators && selectedLegislators.legs.length > 0 && selectedLegislators.roles.length > 0) {
        const legislatorIds = selectedLegislators.legs.map((legislator) => legislator.id);

        standingCommittees = standingCommittees
            .map((committee) => {
                // Filter meetingTimes within each committee
                const filteredMeetingTimes = committee.meetingTimes.map((meeting) => {
                    // Filter bills within each meeting
                    const filteredBills = meeting.bills.filter((bill) => {
                        const isSponsor =
                            selectedLegislators.roles.includes("Sponsor") && legislatorIds.includes(bill.sponsorId);

                        const isRequester =
                            selectedLegislators.roles.includes("Requester") &&
                            bill.requesterType === "LEGISLATOR" &&
                            legislatorIds.includes(bill.requesterId);

                        const isMember =
                            selectedLegislators.roles.includes("Member") &&
                            committee.memberships?.some((membership) => legislatorIds.includes(membership.legislatorId));

                        return isSponsor || isRequester || isMember;
                    });

                    return {
                        ...meeting,
                        bills: filteredBills,
                    };
                });

                const validMeetings = filteredMeetingTimes.filter((meeting) => meeting.bills.length > 0);

                return validMeetings.length > 0
                    ? { ...committee, meetingTimes: validMeetings }
                    : null;
            })
            .filter(Boolean);

    }

    if (selectedChambers && selectedChambers.length > 0) {
        standingCommittees = standingCommittees.filter((committee) =>
            selectedChambers.some((chamber) =>
                chamber.enum === committee.chamber));
    }

    if (selectedBills && selectedBills.length > 0) {
        standingCommittees = standingCommittees.filter((committee, indexA) => {
            standingCommittees[indexA].meetingTimes = committee.meetingTimes.filter((meetingTime, indexB) => {
                standingCommittees[indexA].meetingTimes[indexB].bills = meetingTime.bills.filter((bill) =>
                    selectedBills.some((billFilter) =>
                        billFilter.billNumber === bill.billNumber) &&
                        (dateRange ?
                            matchesMeetingsByDateRange(meetingTime.meetingTime, dateRange) :
                                new Date(meetingTime.meetingTime) >= new Date().setHours(0,0,0))
                )
                return meetingTime.bills && meetingTime.bills.length > 0;
            })
            return committee.meetingTimes && committee.meetingTimes.length > 0;
        })
    }

    return standingCommittees;
};

export default filterStandingCommittees;